// 高级配置
export default {
  advanced: {
    collapseTitle: {
      operOrdertitle: '计息事件-计息单据',
      orderPooltitle: '单据池',
      interPooltitle: '计息池',
    },
    tabTitle: {
      cashtitle: '现金',
      billtitle: '票据',
      CLtitle: '信用证',
      TFtitle: '贸易融资',
      HNtitle: '海宁订单',
    },
    operOrderTable: {
      order: '业务单据',
      orderPlaceholder: '请选择业务单据',
      event: '事件',
      eventPlaceholder: '请选择事件',
      interestOrder: '计息单据',
      interestOrderPlaceholder: '请选择计息单据',
    },
    // 池
    poolTable: {
      orderDate: '操作时间',
      orderId: '业务单据ID',
      orderNo: '业务单据号',
      orderAmount: '计息金额',
      remark: '备注',
      interestDate: '操作时间',
      interestOrderCode: '计息单据代码',
      paymentAmount: '计息金额(+)',
      receiptAmount: '计息金额(-)',
      interestPaymentAmount: '计息金额(+)',
      interestReceiptAmount: '计息金额(-)',
      interestAmount: '计息金额',
      orderCompanyCode: '单据公司编码',
      orderCompanyName: '单据公司名',
      orderDepartmentCode: '单据部门编码',
      orderDepartmentName: '单据部门名',
      modifyAllowed: '是否允许修改',
    },
    billTable: {
      billType: '票据分类',
    },
    HNTable: {
      customerCode: '客户编码',
      customerName: '客户名称',
    },
    // 计息池-票据
    interBillTable: {
      billNo: '票据号',
      interestAmount: '票据金额',
      endorseDepartmentCode: '背书部门代码',
      endorseDepartmentName: '背书部门名称',
      endorseAmount: '背书金额',
      duePaymentDate: '到期支付金额',
    },
    // 计息池-信用证
    interCLTable: {
      orderCode: '业务单据代码',
      internationalClAmount: '国际信用证开证金额',
      internationalPayAmount: '国际信用证付款金额',
      domesticClAmount: '国内信用证开证金额',
      domesticPayAmount: '国内信用证付款金额',
    },
    btnList: {
      save: '保存',
      add: '新增',
      delete: '删除',
    },
    msg: {
      noData: '您还未选择任何数据！',
      deleteSuccess: '删除成功！',
      cancelled: '已取消！',
      saveSussess: '保存成功！',
      saveFail: '保存失败！',
    },
  },
};
